// extracted by mini-css-extract-plugin
module.exports = {"form":"_2b0f02e0526f3f25d7cf2ba146ff15c0"};